<template>
  <!--
    The visible "{LOCATION} NOW OPEN — TASTER PACK / ONLY £16 FOR TWO
    SESSIONS" announce strip was retired site-wide. This component is
    kept as a transparent nav-clearance spacer so the eight views that
    still import it (Home, Putney, Dalston, Pricing, Trainers, FAQs,
    Offices, FindTrainers) don't need a per-view edit to clear the
    fixed top nav (88px desktop / 68px mobile, position: fixed so it
    doesn't take flow space).

    Safe to delete this component entirely if those views are later
    refactored to provide their own top spacing.
  -->
  <div id="banner-spacer" aria-hidden="true"></div>
</template>

<script>
export default {
  name: 'TasterPack',
  // The `location` prop is kept for backwards-compat with existing
  // <TasterPack location="Dalston" /> call sites; no longer rendered.
  props: {
    location: {
      type: String,
      default: 'Putney',
    },
  },
}
</script>

<style lang="scss" scoped>
#banner-spacer {
  width: 100%;
  // Matches the fixed top nav height exactly so the hero sits flush
  // against the nav edge. The previous 12 px (desktop) / 10 px (mobile)
  // of breathing room rendered as a transparent strip showing the white
  // body behind, which read as an unintentional gap between nav and
  // hero on /home + the seven other views that import TasterPack.
  height: var(--nav-h);
}
</style>
